<template>
  <span>
    <template v-if="loading"><font-awesome-icon icon="spinner" /></template>
    <template v-if="!loading">
      <font-awesome-icon
        v-if="isVerified && showVerified"
        :icon="['fas', 'badge-check']"
        style="color: #4894e2"
      />
      {{ displayName }}
    </template>
  </span>
</template>
<script setup>
import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useContactField } from 'src/composables/useContactField';

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  display: {
    type: Array,
    required: true,
  },
  showVerified: {
    type: Boolean,
    default: true,
  },
});

const store = useStore();
const { getContactColumn } = useContactField();
const loading = ref(true);
const displayName = ref('');
const isVerified = ref(false); // This needs to be exposed to the template

const updateContactData = async () => {
  try {
    loading.value = true;
    const contact = await store.dispatch('contacts/fetchContact', props.id);
    if (contact) {
      displayName.value = props.display
        .map((field) => getContactColumn.call(contact, contact, field))
        .join(' ');
      isVerified.value = !!contact.verified_at;
    }
  } catch (error) {
    console.error('Error fetching contact:', error);
  } finally {
    loading.value = false;
  }
};

watch(
  [() => props.id, () => props.display],
  () => {
    if (props.id) {
      updateContactData();
    }
  },
  { immediate: true }
);
</script>
